import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthActions } from "../store/actions";

/** Logs out when an API response proves the authenticated session has expired. */
@Injectable()
export class Http401Interceptor implements HttpInterceptor {
    constructor(private globalStore: Store) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    this.globalStore.dispatch(AuthActions.logout());
                }
                return throwError(() => error);
            }),
        );
    }
}
